import React from 'react';
import { learningStartupBackground } from '../utils/startupAppearance';

/** Inline styles are intentional: this fallback renders before lazy page CSS. */
export default function LearningStartup() {
  return <div role="status" aria-live="polite" style={{ minHeight: '100vh',
    background: learningStartupBackground, color: '#786a53', display: 'flex',
    justifyContent: 'center', alignItems: 'center', fontSize: 16 }}>
    正在准备学习…
  </div>;
}
